import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import LogFileCellRenderer from 'components/common/logFileCellRenderer'
import { formatDate } from 'utils/helpers'

export const getColumns = () =>
  [
    {
      headerName: 'ID',
      field: '_id',
      minWidth: 210,
    },
    {
      headerName: 'Status',
      field: 'status',
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <span className="capitalize">
            {params.value?.split('_')?.join(' ')}
          </span>
        )
      },
      maxWidth: 170,
    },
    {
      headerName: 'Operation Type',
      field: 'operationType',
      cellRenderer: (params: ICellRendererParams) => {
        return <span className="capitalize">{params.value}</span>
      },
      minWidth: 130,
    },
    {
      headerName: 'Log File',
      field: 'logFileUrl',
      minWidth: 230,
      cellRenderer: (params: ICellRendererParams) => (
        <LogFileCellRenderer params={params} />
      ),
    },
    {
      headerName: 'Job ID',
      field: 'jobId',
      minWidth: 150,
    },
    {
      headerName: 'Store ID',
      field: 'storeId',
      minWidth: 100,
    },
    {
      headerName: 'Aggregator ID',
      field: 'aggregatorId',
      minWidth: 130,
    },
    {
      headerName: 'Vendor ID',
      field: 'vendorId',
      minWidth: 100,
    },
    {
      headerName: 'Chain ID',
      field: 'chainId',
      minWidth: 130,
    },
    {
      headerName: 'External Status',
      field: 'extStatus',
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <span className="capitalize">
            {params.value?.split('_')?.join(' ')}
          </span>
        )
      },
      minWidth: 150,
    },
    {
      headerName: 'Error',
      field: 'errorDetails.message',
      minWidth: 150,
    },
    {
      headerName: 'Download URL',
      field: 'downloadUrl',
      minWidth: 190,
      cellRenderer: (params: ICellRendererParams) => (
        <LogFileCellRenderer params={params} />
      ),
    },
    {
      headerName: 'Webhook Received Date',
      field: 'webhookReceivedAt',
      minWidth: 190,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value ? formatDate(params.value, { includeTime: true }) : '-',
    },
    {
      headerName: 'Creation Date',
      field: 'createdAt',
      minWidth: 190,
      valueFormatter: (params: ValueFormatterParams) =>
        formatDate(params.value, { includeTime: true }),
    },
  ] as ColDef[]
